(function () {
    'use strict';
    angular.module('Services').factory('ConsolidatedShipmentOrdersTable', ConsolidatedShipmentOrdersTable);
    ConsolidatedShipmentOrdersTable.$inject = [
        'TableLiteFactory',
        'Shipments',
        'toastr'
    ];

    function ConsolidatedShipmentOrdersTable(
        TableLiteFactory,
        Shipments,
        toastr
    ) {
        return function (shipmentData) {
            const consolidatedShipmentOrdersTableData = {
                config: {
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: false,
                    noFooter: true,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentId'
                }, {
                    label: 'CUSTOMER REF NO.',
                    viewName: 'customerReferences'
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName'
                }, {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceProfileName'
                }, {
                    label: 'PACKAGING',
                    viewName: 'packaging'
                }, {
                    label: 'AMOUNT (Ex Tax)',
                    viewName: 'amount'
                }],
                data: [],
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };

            const tableActions = new TableLiteFactory(consolidatedShipmentOrdersTableData,
                {
                    serviceCallback: Shipments.getConsolidationDetails,
                    callbackFormat: ['success', 'error', 'id'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: shipmentData.id
                }
            );

            function buildTableData(data) {
                if (!data) { return consolidatedShipmentOrdersTableData };

                
                tableActions.initializeTableData(data);
                angular.forEach(data, function (item) {
                    item.consignmentId = item.consignmentId || 'N/A';
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';

                    if(item.packages.length != 0) {
                        item.customerReferences = item.packages[0].customerReference || 'N/A';
                    } else {
                        item.customerReferences = 'N/A';
                    }
                    
                    
                    item.amount = Shipments.getShipmentCostFormatted(item).amountFormatted;
                    item.packaging = `${item.packages[0].quantity} x [${item.packaging}]`;
                    consolidatedShipmentOrdersTableData.data.push(item);
                });
            }

            this.tableData = consolidatedShipmentOrdersTableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/ConsolidatedShipmentOrdersTable.js